"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRealDRep = exports.isDRepLike = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var DRepAlwaysAbstain_1 = require("./DRepAlwaysAbstain.js");
var DRepAlwaysNoConfidence_1 = require("./DRepAlwaysNoConfidence.js");
var DRepKeyHash_1 = require("./DRepKeyHash.js");
var DRepScript_1 = require("./DRepScript.js");
var DRepType_1 = require("./DRepType.js");
function isDRepLike(stuff) {
    if (!((0, obj_utils_1.isObject)(stuff) &&
        (0, DRepType_1.isDRepType)(stuff.drepType)))
        return false;
    switch (stuff.drepType) {
        case DRepType_1.DRepType.KeyHash: return (0, DRepKeyHash_1.isIDRepKeyHash)(stuff);
        case DRepType_1.DRepType.Script: return (0, DRepScript_1.isIDRepScript)(stuff);
        case DRepType_1.DRepType.AlwaysAbstain: return true;
        case DRepType_1.DRepType.AlwaysNoConfidence: return true;
        default: return false;
    }
}
exports.isDRepLike = isDRepLike;
function toRealDRep(like) {
    switch (like.drepType) {
        case DRepType_1.DRepType.KeyHash: return new DRepKeyHash_1.DRepKeyHash(like);
        case DRepType_1.DRepType.Script: return new DRepScript_1.DRepScript(like);
        case DRepType_1.DRepType.AlwaysAbstain: return new DRepAlwaysAbstain_1.DRepAlwaysAbstain(like);
        case DRepType_1.DRepType.AlwaysNoConfidence: return new DRepAlwaysNoConfidence_1.DRepAlwaysNoConfidence(like);
        default: throw new Error("invalid 'DRepLike'");
    }
}
exports.toRealDRep = toRealDRep;
